import { useNavigate } from "@tanstack/react-router";
import { CheckCircle2 } from "lucide-react";
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { buildProviderInviteRedirect } from "../utils/invite-redirect";

export function InvitationAcceptedCard({
  token,
  businessUnitName,
  isSignedIn,
}: {
  token: string;
  businessUnitName: string;
  isSignedIn: boolean;
}) {
  const navigate = useNavigate();

  return (
    <>
      <CardHeader className="items-center text-center">
        <div className="rounded-full bg-green-100 p-3 mb-2">
          <CheckCircle2 className="h-6 w-6 text-green-600" />
        </div>
        <CardTitle className="text-xl">Already on the roster</CardTitle>
        <CardDescription>
          You&apos;ve already joined {businessUnitName}.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {isSignedIn ? (
          <Button
            className="w-full"
            onClick={() => navigate({ to: "/provider/home" })}
          >
            Open your workspace
          </Button>
        ) : (
          <Button
            className="w-full"
            onClick={() =>
              navigate({
                to: "/auth-provider/signin",
                search: { redirect: buildProviderInviteRedirect(token) },
              })
            }
          >
            Sign in
          </Button>
        )}
      </CardContent>
    </>
  );
}
